import { Switch } from 'antd'
import styles from './index.module.sass'
import classNames from 'classnames'
import { useRef } from 'react'

export const BuyerItem = ({ enabled, name, offersCount, onChange, id, onClick, selectedRustmixBuyer }: IArgs) => {
    const elemRef = useRef(null);
    const switchRef: any = useRef(null);
    // selectedRustmixBuyer === id && styles.activeItem
    return (
        <div ref={elemRef} className={classNames(styles.root)} onClick={() => onChange(!enabled)}>  
            <Switch ref={switchRef} checked={enabled}/>
            <span className={styles.name}>{name}</span>
            <span className={styles.offersCount}>{offersCount}</span>
        </div>
    )
}

interface IArgs {
    id: number
    enabled: boolean,
    name: string,
    offersCount: number,
    onChange: (e: any) => void,
    onClick: () => void,
    selectedRustmixBuyer: number,
}